"use client";

import { useLocale } from "@/context/LocaleContext";
import { I18nData } from "@/types/i18n";
import Footer from "./footer";

interface FooterWrapperProps {
  i18nData?: I18nData;
}

export default function FooterWrapper({ i18nData }: FooterWrapperProps) {
  const { locale } = useLocale();
  return <Footer i18nData={i18nData} locale={locale} />;
}